import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export type EmailDynText = {
	ZaznamId: number,
	DynZnac: string,
	Text: string,
	EmailTypPzn: number,
};

export type EmailTextRefDTO = {
	ZaznamId: number,
	EmailText: string,
	EmailTypPzn: number,
	LanguageId: number | null,
	EmailPredmet: string,
	PodpisText: string,
};

export enum UserMessageEnum
	{
	Success = 1,
	Info = 2,
	Warning = 3,
	Error = 4
}

export type UserMessageDTO = {
	Title: string,
	Message: string,
	Type: UserMessageEnum,
};

const edit = {
	Poznamka: null as string | null,
	EmailTypPzn: null as number | null,
	Emailpredmet: null as string | null,
	Emailtext: null as string | null,
	PodpisText: null as string | null,
	Activated: null as boolean | null,
	ZaznamId: null as number | null,

	EmailDynTextList: null as EmailDynText[] | null,
	EmailTextRefList: null as EmailTextRefDTO[] | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		EmailTypPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {
		UserMessageList: null as UserMessageDTO[] | null,
		EmailDynTextId: null as number | null,
	},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
